/** The newline keeps both tile labels on two lines at any tile width; rendered with whiteSpace: pre-line. */
export const PHOTO_UPLOAD_FROM_COMPUTER_TEXT = 'Add from\ncomputer';
export const PHOTO_UPLOAD_FROM_PHONE_TEXT = 'Add from\nphone';

/** Photos uploaded through Rental Manager are stored with a federated photo URL; feed photos keep the partner's URL. */
export const FEDERATED_PHOTO_URL_PREFIXES = [
  'https://photos.zillowstatic.com/fp/',
  'https://photos.test.zillow.net/fp/',
];
